<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tgX48D/tc-custom/9781488040252.jpg?1741057995165" alt="This image is the cover for the book Justice at Morgan Mesa"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Justice at Morgan Mesa
      </h1>
      <p class="bookDescription body article font2">
        <b>Her father’s killer is back—and now he’s after her<br/><br/></b>Attorney Vanessa Ford was only a child when her father was murdered, but now she’s returned to her hometown, determined to find answers to the unsolved case. When the attacks start, she knows she’s close to the truth…too close. But with policeman Levi Hawk volunteering to work with her on the investigation, can Vanessa finally find answers…or will deadly trouble strike them first?<br/><br/><b>From Love Inspired Suspense: Courage. Danger. Faith.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jenna Night
      </h2>
      
      <p class="authorDescription body article">Jenna Night comes from a family of southern-born natural storytellers. Her parents were avid readers and the house was always filled with books. No wonder she grew up wanting to tell her own stories. She&#39;s lived on both coasts, but currently resides in the Inland Northwest where she&#39;s astonished by the occasional glimpse of a moose, a herd of elk or a soaring eagle.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?066ea1e4